module.exports = __webpack_public_path__ + "static/img/landing2_05_signUpBtn.646e849.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/landing2_05_signUpBtn.webp
// module id = KsUj
// module chunks = 0